// extracted by mini-css-extract-plugin
module.exports = {"clearfix":"LocaleSelect_clearfix_-kzr8"};